// src/hooks/useTables.js
import { useState, useEffect } from 'react';
import { API } from '../api/config';

const API_URL = `${API.MESAS}/status`;
//const API_URL = "http://localhost:8091/status";
export function useTables() {
    const [status, setStatus] = useState(null); // 'Closed', 'Available', 'Full'
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const response = await fetch(API_URL);
                if (!response.ok) {
                    throw new Error("Erro ao buscar status do servidor");
                }
                const data = await response.json();
                setStatus(data.status);
            } catch (err) {
                console.error("Erro ao verificar disponibilidade das mesas:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchStatus();
    }, []);

    return { status, loading, error };
}